export const getToken = async (): Promise<{ token: string; cookie: string }> => {
  const res = await fetch(`https://${process.env.API_ENDPOINT}/api/form`);

  if (!res.ok) {
    throw new Error(`Token request failed with status ${res.status}`);
  }

  const token = res.headers.get('X-RequestVerificationToken');
  const setCookies = res.headers.getSetCookie();

  let rvtCookie = '';

  for (const setCookie of setCookies) {
    if (setCookie.startsWith('__RequestVerificationToken=')) {
      rvtCookie = setCookie;
      break;
    }
  }

  if (!token) {
    throw new Error('Unable to authorize request. No token returned from token /api/form');
  }

  if (!rvtCookie) {
    throw new Error(
      'Unable to authorize request. No __RequestVerificationToken Set-Cookie returned from token /api/form'
    );
  }

  return { token, cookie: rvtCookie };
};
